/* Tysk katalog for locale-invoice-live.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('de', {
  'actionApproval.approve': 'Genehmigen',
  'actionApproval.approveAction': 'Genehmigen: {action}',
  'live.reviewTitle': 'Rechnung prüfen',
  'live.reviewInvoice': 'Prüfe die Rechnung unten, bevor du sie genehmigst.',
  'live.deliveryLabel': 'Senden als',
  'live.approveSend': 'Genehmigen und senden',
  'live.approveIssue': 'Genehmigen und erstellen',
  'actionApproval.label.send_offer': 'Angebot senden',
  'actionApproval.label.send_credit_note': 'Gutschrift senden',
  'actionApproval.label.send_reminder': 'Zahlungserinnerung ohne Gebühr senden',
  'actionApproval.label.post_purchase': 'Einkauf erfassen und buchen',
  'actionApproval.label.reverse_purchase': 'Einkauf stornieren',
  'actionApproval.label.post_manual_voucher': 'Beleg buchen',
  'actionApproval.label.reverse_voucher': 'Beleg stornieren',
  'actionApproval.label.approve_payroll_run': 'Lohnlauf genehmigen und buchen',
  'actionApproval.label.reverse_payroll_run': 'Lohnlauf stornieren',
  'actionApproval.label.record_payroll_submission': 'Bestätigen, dass die A-melding außerhalb von Plumme übermittelt wurde',
  'actionApproval.label.close_accounting_year': 'Geschäftsjahr genehmigen und abschließen',
  'actionApproval.label.reopen_accounting_year': 'Geschäftsjahr wieder öffnen',
  'actionApproval.label.delete_invoice_drafts': 'Rechnungsentwürfe löschen',
  'actionApproval.label.delete_purchase_draft': 'Einkaufsentwurf löschen',
  'actionApproval.label.delete_payroll_draft': 'Lohnentwurf löschen',
  'actionApproval.label.delete_project': 'Projekt löschen',
  'actionApproval.label.invite_business_member': 'Benutzer zum Unternehmen einladen',
  'actionApproval.label.remove_business_member': 'Zugriff des Benutzers auf das Unternehmen entfernen',
  'actionApproval.label.cancel_business_invite': 'Einladung zurückziehen',
  'live.reading': 'Lese das Formular und wähle den nächsten Schritt …',
  'live.open_editor': 'Öffne den Rechnungseditor …',
  'live.set_layout': 'Wechsle die Ansicht …',
  'live.set_customer': 'Wähle den Kunden …',
  'live.set_field': 'Fülle ein Feld aus …',
  'live.set_line': 'Fülle eine Rechnungszeile aus …',
  'live.remove_line': 'Entferne eine Rechnungszeile …',
  'live.open_customer_form': 'Bereite einen neuen Kunden vor …',
  'live.open_product_form': 'Bereite ein neues Produkt vor …',
  'live.review': 'Öffne die Vorschau …',
  'live.request_save': 'Bereite die Genehmigung vor …',
  'live.finish': 'Prüfe das Ergebnis …',
  'live.ask_user': 'Klärung erforderlich …',
  'live.approval': 'Warte darauf, dass du das Formular prüfst und speicherst.',
  'live.customerApproval': 'Prüfe den neuen Kunden im Formular. Sobald du speicherst, mache ich mit der Rechnung weiter.',
  'live.productApproval': 'Prüfe das neue Produkt, den Preis und die MwSt. im Formular. Sobald du speicherst, mache ich mit der Rechnung weiter.',
  'live.customerSaved': 'Der Kunde ist gespeichert. Weiter mit der Rechnung.',
  'live.productSaved': 'Das Produkt ist gespeichert. Weiter mit der Rechnung.',
  'live.cancelled': 'Die Erstellung wurde abgebrochen. Die Arbeit an der Rechnung ist pausiert.',
  'live.notApplied': 'Das Feld wurde nicht wie erwartet aktualisiert. Ich habe angehalten, damit du das Formular prüfen kannst.',
  'live.limit': 'Ich habe die maximale Anzahl an Schritten erreicht. Prüfe das Formular und beschreibe, was noch fehlt.',
  'live.done.open_editor': 'Der Rechnungseditor ist geöffnet.',
  'live.done.set_layout': 'Die Ansicht wurde geändert.',
  'live.done.set_customer': 'Der Kunde ist ausgewählt.',
  'live.done.set_field': 'Das Feld ist ausgefüllt und geprüft.',
  'live.done.set_line': 'Die Rechnungszeile ist ausgefüllt und geprüft.',
  'live.done.remove_line': 'Die Rechnungszeile wurde entfernt.',
  'control.productRequired': 'Das Produkt ist nicht im aktiven Produktregister vorhanden.',
  'control.intro': 'Sag mir, welche Rechnung du erstellen möchtest. Ich fülle das Formular aus und kann benötigte Kunden und Produkte anlegen. Bitte mich ausdrücklich, die Rechnung zu erstellen und zu senden, wenn ich sie abschließen soll.',
  'live.create_customer': 'Speichere den Kunden …',
  'live.create_product': 'Speichere das Produkt …',
  'live.issue_invoice': 'Erstelle die Rechnung …',
  'live.send_invoice': 'Erstelle und sende die Rechnung …',
  'live.finished': 'Das Ausfüllen ist abgeschlossen. Die Änderungen wurden im Rechnungsformular geprüft.',
  'live.clarification': 'Beschreibe, was du als Nächstes mit der Rechnung tun möchtest.',
  'live.invoiceIssued': 'Die Rechnung ist erstellt. Sie wurde nicht gesendet.',
  'live.invoiceSent': 'Die Rechnung wurde per E-Mail gesendet.',
  'live.emailRequired': 'Zum Senden brauche ich die E-Mail-Adresse des Kunden und die Absender-E-Mail in den Unternehmenseinstellungen. Gib die Empfängeradresse zusammen mit einer neuen Anweisung zum Senden an.',
  'live.authorizationRequired': 'Schreib ausdrücklich, was du erstellen oder senden möchtest.',
  'live.deliveryUncertain': 'Der Versand wurde bereits versucht. Prüfe den Versandstatus in der Rechnungsliste vor einem neuen Versuch, damit der Kunde die Rechnung nicht doppelt erhält.',
  'live.deliveryNotSent': 'Die Rechnung ist erstellt, aber der Versand wurde nicht bestätigt. Prüfe den Versandstatus in der Rechnungsliste.',
  'live.ambiguousRecord': 'Mehrere Kunden oder Produkte haben denselben Namen. Wähle zuerst den richtigen Eintrag.',
  'live.actionBusy': 'Ein Speicher- oder Sendevorgang läuft bereits.',
  'appControl.changed': 'Die Seite oder das Unternehmen hat sich geändert. Prüfe die Seite und bitte mich, fortzufahren.',
  'appControl.unsupported': 'Dieses Steuerelement musst du direkt auf der Seite verwenden.',
  'appControl.authorization': 'Sag mir, welche Aktion ich ausführen soll.',
  'appControl.manual': 'Schließe diesen Schritt direkt auf der Seite ab, dann kann ich fortfahren.',
  'appControl.option': 'Diese Option ist in diesem Feld nicht verfügbar.',
  'appControl.repeated': 'Die Aktion wurde bereits versucht. Prüfe das Ergebnis auf der Seite, bevor du fortfährst.',
  'actionApproval.title': 'Aktion genehmigen',
  'actionApproval.body': 'Prüfe die Aktion und die Angaben unten. Die Genehmigung gilt nur für diesen Schritt.',
  'actionApproval.confirm': 'Genehmigen und ausführen',
  'actionApproval.proposal': 'Vorgeschlagene Aktion',
  'actionApproval.context': 'Von der Aktion betroffene Angaben',
  'actionApproval.cancel': 'Abbrechen',
  'actionApproval.mcp': 'Aktion einer verbundenen KI',
  'actionApproval.failed': 'Die Aktion konnte nicht ausgeführt werden. Hol einen neuen Vorschlag und versuche es erneut.',
  'actionApproval.loading': 'Aktion wird geladen ...',
  'actionApproval.done': 'Die Aktion wurde ausgeführt.',
  'actionApproval.business': 'Unternehmen',
  'actionApproval.writeScope': 'Die KI kann Schreibaktionen vorschlagen. Jede Aktion muss von dir in Plumme genehmigt werden, bevor sie ausgeführt wird.',
  'actionApproval.label.create_invoice_draft': 'Rechnungsentwurf erstellen',
  'actionApproval.label.register_invoice_payment': 'Rechnungszahlung erfassen',
  'actionApproval.label.save_draft': 'Entwurf speichern',
  'actionApproval.label.send_invoice': 'Rechnung senden',
  'actionApproval.label.issue_invoice': 'Rechnung ausstellen',
  'actionApproval.label.create_customer': 'Kunden anlegen',
  'actionApproval.label.create_product': 'Produkt anlegen',
  'actionApproval.label.invoice': 'Rechnung',
  'actionApproval.label.invoiceId': 'Rechnungs-ID',
  'actionApproval.label.customer': 'Kunde',
  'actionApproval.label.customerName': 'Kundenname',
  'actionApproval.label.currency': 'Währung',
  'actionApproval.label.amount': 'Betrag',
  'actionApproval.label.date': 'Datum',
  'actionApproval.label.dueDate': 'Fälligkeitsdatum',
  'actionApproval.label.lines': 'Zeilen',
  'actionApproval.label.quantity': 'Menge',
  'actionApproval.label.unitPrice': 'Einzelpreis',
  'actionApproval.label.vatRate': 'MwSt.-Satz',
  'actionApproval.label.description': 'Beschreibung',
  'actionApproval.label.business': 'Unternehmen',
  'actionApproval.label.expires': 'Gültig bis',
  'actionApproval.label.recipientEmail': 'Empfänger',
  'actionApproval.label.fields': 'Felder',
  'actionApproval.label.label': 'Name',
  'actionApproval.label.value': 'Wert',
  'actionApproval.label.text': 'Angaben auf der Seite',
  'actionApproval.label.action': 'Aktion',
  'actionApproval.label.click': 'Tippen',
  'actionApproval.label.fill': 'Ausfüllen',
  'actionApproval.label.select': 'Auswählen',
  'actionApproval.label.check': 'Auswahl ändern',
  'actionApproval.label.checked': 'Ausgewählt',
  'actionApproval.label.post': 'Buchen',
  'actionApproval.label.approve': 'Lohnlauf genehmigen',
  'actionApproval.label.close_year': 'Geschäftsjahr genehmigen und abschließen',
  'actionApproval.label.reopen_year': 'Geschäftsjahr wieder öffnen',
  'actionApproval.label.manage_members': 'Zugriffe ändern',
  'actionApproval.label.delete': 'Löschen oder stornieren',
  'actionApproval.label.submit': 'Übermitteln',
  'actionApproval.label.expense': 'Einkauf',
  'actionApproval.label.supplier': 'Lieferant',
  'actionApproval.label.year': 'Jahr',
  'actionApproval.label.records': 'Einträge',
});
